import {
  SEND_PEER_INVITATION,
  SEND_PEER_INVITATION_FAILED,
  SEND_PEER_INVITATION_SUCCES,
  SEND_EMAIL_TA,
  SEND_EMAIL_TA_SUCCES,
  SEND_EMAIL_TA_FAILED
} from "./constants";

const initialState = {};

export default function emails(state = initialState, action) {
  switch (action.type) {
    case SEND_PEER_INVITATION:
      return {};

    case SEND_PEER_INVITATION_FAILED:
      return {};

    case SEND_PEER_INVITATION_SUCCES:
      return {};

    case SEND_EMAIL_TA:
      return {};

    case SEND_EMAIL_TA_FAILED:
      return {};

    case SEND_EMAIL_TA_SUCCES:
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/emails/reducer.js